interface HeaderProps {
  query?: string;
  departmentLabel?: string;
  showQuery?: boolean;
  runInProgress?: boolean;
  onRuns: () => void;
  onCancel?: () => void;
  onNewSearch?: () => void;
}

export function Header({
  query,
  departmentLabel,
  showQuery,
  runInProgress,
  onRuns,
  onCancel,
  onNewSearch,
}: HeaderProps) {
  return (
    <header className="hdr">
      <div className="hdr-left">
        <div className="hdr-brand-lockup">
          <img src={`${import.meta.env.BASE_URL}logo-ccf.svg`} alt="Cleveland Clinic" className="hdr-ccf-logo" />
          <div className="hdr-brand-stack">
            <span className="hdr-org">Cleveland Clinic</span>
            <span className="hdr-product">Clinical Search</span>
          </div>
        </div>
        {showQuery && departmentLabel ? (
          <span className="hdr-dept">{departmentLabel}</span>
        ) : null}
        {showQuery && query ? (
          <span className="hdr-sub" title={query}>
            {query}
          </span>
        ) : null}
      </div>
      <div className="hdr-right">
        {onNewSearch ? (
          <button type="button" className="btn-ghost-hdr" onClick={onNewSearch}>
            New search
          </button>
        ) : null}
        <button type="button" className="btn-ghost-hdr" onClick={onRuns}>
          Runs
        </button>
        {runInProgress && onCancel ? (
          <button type="button" className="hdr-cancel" onClick={onCancel}>
            Cancel
          </button>
        ) : null}
      </div>
    </header>
  );
}
